import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

interface SectionHeaderProps {
  title: string
  icon: LucideIcon
  right?: ReactNode
}

export function SectionHeader({ title, icon: Icon, right }: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between" role="heading" aria-level={2} aria-label={title}>
      <div className="flex items-center gap-2">
        <Icon className="h-5 w-5 text-primary" aria-hidden="true" />
        <h2 className="text-lg font-semibold">{title}</h2>
      </div>
      {right ? <div className="flex items-center gap-1">{right}</div> : null}
    </div>
  )
}
